import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideBlockList,
} from "../GuideBlocks.js";

const WhatIsStructuredThinkingSection = ({ heading, accentIndex = 1, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="what-is-structured-thinking"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Structured thinking is a deliberate way of processing information before reaching a conclusion or
      making a decision.
    </GuideLead>
    <p className="guide-panel__p">Instead of jumping to assumptions, structured thinking encourages you to:</p>
    <GuideBlockList
      items={[
        "Understand what actually happened.",
        "Separate facts from interpretations.",
        "Look for evidence.",
        "Choose your response thoughtfully.",
      ]}
    />
    <p className="guide-panel__p">
      Think of it as creating a roadmap for your mind. Without a roadmap, thoughts often wander into
      fear, overthinking, and confusion. With a roadmap, they become focused, logical, and productive.
    </p>
    <GuideCallout>
      Structured thinking does not remove emotions. It helps you understand them without allowing them
      to control your decisions.
    </GuideCallout>
  </GuidePanel>
);

export default WhatIsStructuredThinkingSection;
